import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  graphWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: '1rem',
    marginTop: '1rem',
    marginBottom: '1rem',
    height: '100%',

    '& > .js-plotly-plot > .plotly > .svg-container > svg': {
      overflow: 'unset',
    },
  },
}));
